module.exports = __webpack_public_path__ + "static/media/mbaimclr.32c10656.png";